<div class="bg-light min-h-[90vh] py-5 px-6">
  <div class="max-w-6xl mx-auto min-h-[70vh] bg-white rounded p-6 space-y-8">
    <h2 class="text-2xl font-bold text-gray-800 mb-8">Mis postulaciones</h2>
    <app-loading
      *ngIf="isLoading"
      [text]="'Cargando postulaciones'"
    ></app-loading>
    <div *ngIf="!isLoading">
      <ng-container
        *ngIf="!isLoading && applications.length > 0; else noApplications"
      >
        <div
          *ngFor="let app of applications"
          class="p-4 border border-gray-300 rounded mb-5 pb-10"
        >
          <div class="flex items-center justify-between flex-wrap gap-3">
            <div>
              <div class="text-lg font-semibold text-gray-800">
                {{ app.jobOffer.title }}
              </div>
              <div class="text-sm text-gray-500">
                {{ app.company.commercialName }}
              </div>
              <div class="text-xs text-gray-400 mt-1">
                {{ app.jobOffer.subTitle }}
              </div>
            </div>
            <button
              (click)="goToCompany(app)"
              class="px-3 py-1 rounded-md border border-primary text-primary text-sm font-medium hover:bg-primary hover:text-white transition"
            >
              Ver detalles
            </button>
          </div>
          <div
            class="relative mt-8 h-12 items-center justify-between hidden md:flex"
          >
            <div
              class="absolute top-1/2 left-0 right-0 h-2 bg-gray-300 rounded-full z-0"
            ></div>
            <div
              class="absolute top-1/2 h-2 rounded-full z-10 transition-all duration-500"
              [ngStyle]="{
                width: getTimelineWidth(app.statusProcess),
                backgroundColor: '#4F48ED'
              }"
            ></div>
            <div class="flex justify-between w-full relative z-20 mt-6">
              <div class="flex flex-col items-center">
                <div
                  class="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg"
                  [ngClass]="{
                    'bg-primary': isStepActive(app.statusProcess, 'Enviado'),
                    'bg-gray-300': !isStepActive(app.statusProcess, 'Enviado')
                  }"
                >
                  1
                </div>
                <span class="mt-2 text-xs text-gray-700">Enviado</span>
              </div>
              <div class="flex flex-col items-center">
                <div
                  class="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg"
                  [ngClass]="{
                    'bg-primary': isStepActive(app.statusProcess, 'Revisado'),
                    'bg-gray-300': !isStepActive(app.statusProcess, 'Revisado')
                  }"
                >
                  2
                </div>
                <span class="mt-2 text-xs text-gray-700">Revisado</span>
              </div>
              <div class="flex flex-col items-center">
                <div
                  class="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg"
                  [ngClass]="{
                    'bg-primary': isStepActive(
                      app.statusProcess,
                      'Preseleccionado'
                    ),
                    'bg-gray-300': !isStepActive(
                      app.statusProcess,
                      'Preseleccionado'
                    )
                  }"
                >
                  3
                </div>
                <span class="mt-2 text-xs text-gray-700">Preseleccionado</span>
              </div>
              <div class="flex flex-col items-center">
                <div
                  class="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg"
                  [ngClass]="{
                    'bg-primary': isStepActive(
                      app.statusProcess,
                      'Seleccionado'
                    ),
                    'bg-gray-300': !isStepActive(
                      app.statusProcess,
                      'Seleccionado'
                    )
                  }"
                >
                  4
                </div>
                <span class="mt-2 text-xs text-gray-700">Seleccionado</span>
              </div>
            </div>
          </div>
          <div class="mt-6 md:hidden">
            <span
              class="px-3 py-1 text-sm font-medium rounded-full"
              [ngClass]="{
                'bg-blue-100 text-blue-700': app.statusProcess === 'Enviado',
                'bg-yellow-100 text-yellow-700':
                  app.statusProcess === 'Revisado',
                'bg-orange-100 text-orange-700':
                  app.statusProcess === 'Preseleccionado',
                'bg-green-100 text-green-700':
                  app.statusProcess === 'Seleccionado'
              }"
            >
              {{ app.statusProcess }}
            </span>
          </div>
        </div>
      </ng-container>
      <ng-template #noApplications>
        <div class="text-center text-gray-500 py-20">
          <p class="text-lg">Aún no te has postulado a ninguna oferta.</p>
          <p class="text-sm mt-2">
            Postúlate a una oferta laboral en el menú
            <strong>"Empleos"</strong>.
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
